// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mailing-recipients-main__header{
    font-size: 4rem;
    font-weight: 600;
    text-align: center;
}

.mailing-item-info__recipient-photo {
    width: 5.4rem !important;
    height: 5.4rem !important;
    border-radius: 50%;
}

.mailing-item-info__recipient-photo svg {
    width: 100% !important;
    height: 100% !important;
}

.mailing-recipients {
    padding-left: 60px;
    width: 95%;
}

.mailing-table > tbody > tr > td.mailing-item-info__recipient-name {
    min-width: 10rem;
    text-align: left;
    white-space: normal;
    text-overflow: clip;
    overflow-wrap: break-word;
}

.mailing-item-info__channel-row {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    height: 3rem;
}

.mailing-item-info__channel-externalid {
    vertical-align: 0.6rem;
    margin-left: 1.8rem;
}

th.mailing-item-header__contact {
    text-align: left;
}

.mailing-item-info__error-info {
    display: inline-block;
    width: 2.5rem;
    height: 2.5rem;
    background-color: #e5e5e5;
    border-radius: 50%;
    margin-left: 1rem;
    cursor: pointer;
    position: absolute;
}

.mailing-item-info__recipients-list-block {
    overflow-y: auto;
}

.mailing-item-info__status-container {
    position: relative;
}`, "",{"version":3,"sources":["webpack://./src/app/mailing/mailing-main/mailing-list/mailing-recipients/MailingRecipientsList.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":[".mailing-recipients-main__header{\r\n    font-size: 4rem;\r\n    font-weight: 600;\r\n    text-align: center;\r\n}\r\n\r\n.mailing-item-info__recipient-photo {\r\n    width: 5.4rem !important;\r\n    height: 5.4rem !important;\r\n    border-radius: 50%;\r\n}\r\n\r\n.mailing-item-info__recipient-photo svg {\r\n    width: 100% !important;\r\n    height: 100% !important;\r\n}\r\n\r\n.mailing-recipients {\r\n    padding-left: 60px;\r\n    width: 95%;\r\n}\r\n\r\n.mailing-table > tbody > tr > td.mailing-item-info__recipient-name {\r\n    min-width: 10rem;\r\n    text-align: left;\r\n    white-space: normal;\r\n    text-overflow: clip;\r\n    overflow-wrap: break-word;\r\n}\r\n\r\n.mailing-item-info__channel-row {\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n    height: 3rem;\r\n}\r\n\r\n.mailing-item-info__channel-externalid {\r\n    vertical-align: 0.6rem;\r\n    margin-left: 1.8rem;\r\n}\r\n\r\nth.mailing-item-header__contact {\r\n    text-align: left;\r\n}\r\n\r\n.mailing-item-info__error-info {\r\n    display: inline-block;\r\n    width: 2.5rem;\r\n    height: 2.5rem;\r\n    background-color: #e5e5e5;\r\n    border-radius: 50%;\r\n    margin-left: 1rem;\r\n    cursor: pointer;\r\n    position: absolute;\r\n}\r\n\r\n.mailing-item-info__recipients-list-block {\r\n    overflow-y: auto;\r\n}\r\n\r\n.mailing-item-info__status-container {\r\n    position: relative;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
